module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApBAMAAABaTh3FAAAAJFBMVEUAAABDQ0NAQEBDQ0NCQkJDQ0M9PT1DQ0NERERFRUVFRUVERERLN7ZdAAAAC3RSTlMA9yDgUdgZRZWBXGPBea4AAABJSURBVCjPYyAEXLAJsgg6YBF13B2ARan01gRsSsNGlRKplCkQm1Ll3SClmKK7sEQMk/XGAgZsisVHFVNZsQI2xTsYsCmegGADAIuxLsZ33RqyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/backIcon-black.png
// module id = uNvp
// module chunks = 317